import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { FormComponent } from "../dynamic-form/form/form.component";
import { FormInputConfig } from '../../interfaces/form-input-config';

@Component({
  selector: 'app-shared-dialog',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule, CheckboxModule, FormsModule, InputTextModule, ReactiveFormsModule, FormComponent],
  templateUrl: './shared-dialog.component.html',
  styleUrl: './shared-dialog.component.scss'
})
export class SharedDialogComponent implements OnChanges {
  @Input() visible: boolean = false;
  @Input() title: string = '';
  @Input() formValues: any = null;  // Receive pre-filled values for editing
  @Output() save = new EventEmitter<any>();
  @Output() cancel = new EventEmitter<void>();

  form: FormInputConfig[] = [];
  @Input() dynamicFormConfig: FormInputConfig[] = [];
  validationErrors: any = {};

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['formValues']) {
      this.initForm();
    }
  }

  ngOnInit(): void {
    this.initForm();
  }

  // Initialize or patch the form
  initForm() {
    this.form = this.dynamicFormConfig.map(field => ({
      ...field,
      defaultValue: this.formValues ? this.formValues[field.name] : field.defaultValue,
    }));
  }

  // Handle form changes
  valueChanged(data: any) {
    this.formValues = {
      ...data
    };
  }

  onSave(event?:any) {
    this.save.emit(this.formValues);  // Send the updated form values
    this.visible = false;
  }

  onClose() {
    this.cancel.emit();
    this.visible = false;
  }
}
